// @ts-nocheck
import client from "../../utils/axios";
import { useQuery, queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { ResourceAdminIndexQueryResponse, ResourceAdminIndexQueryParams, ResourceAdminIndex401 } from "../models/ResourceAdminIndex";
import type { QueryObserverOptions, UseQueryResult, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";

 type ResourceAdminIndexClient = typeof client<ResourceAdminIndexQueryResponse, ResourceAdminIndex401, never>;
type ResourceAdminIndex = {
    data: ResourceAdminIndexQueryResponse;
    error: ResourceAdminIndex401;
    request: never;
    pathParams: never;
    queryParams: ResourceAdminIndexQueryParams;
    headerParams: never;
    response: ResourceAdminIndexQueryResponse;
    client: {
        parameters: Partial<Parameters<ResourceAdminIndexClient>[0]>;
        return: Awaited<ReturnType<ResourceAdminIndexClient>>;
    };
};
export const resourceAdminIndexQueryKey = (params?: ResourceAdminIndex["queryParams"]) => ["api", "v5", "admin", "resources", ...(params ? [params] : [])] as const;
export type ResourceAdminIndexQueryKey = ReturnType<typeof resourceAdminIndexQueryKey>;
export function resourceAdminIndexQueryOptions(params?: ResourceAdminIndex["queryParams"], options: ResourceAdminIndex["client"]["parameters"] = {}) {
    const queryKey = resourceAdminIndexQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<ResourceAdminIndex["data"], ResourceAdminIndex["error"]>({
                method: "get",
                url: `/api/v5/admin/resources`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary list
 * @link /api/v5/admin/resources
 */
export function useResourceAdminIndex<TData = ResourceAdminIndex["response"], TQueryData = ResourceAdminIndex["response"], TQueryKey extends QueryKey = ResourceAdminIndexQueryKey>(params?: ResourceAdminIndex["queryParams"], options: {
    query?: Partial<QueryObserverOptions<ResourceAdminIndex["response"], ResourceAdminIndex["error"], TData, TQueryData, TQueryKey>>;
    client?: ResourceAdminIndex["client"]["parameters"];
} = {}): UseQueryResult<TData, ResourceAdminIndex["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? resourceAdminIndexQueryKey(params);
    const query = useQuery({
        ...resourceAdminIndexQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseQueryResult<TData, ResourceAdminIndex["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}
export const resourceAdminIndexSuspenseQueryKey = (params?: ResourceAdminIndex["queryParams"]) => ["api", "v5", "admin", "resources", ...(params ? [params] : [])] as const;
export type ResourceAdminIndexSuspenseQueryKey = ReturnType<typeof resourceAdminIndexSuspenseQueryKey>;
export function resourceAdminIndexSuspenseQueryOptions(params?: ResourceAdminIndex["queryParams"], options: ResourceAdminIndex["client"]["parameters"] = {}) {
    const queryKey = resourceAdminIndexSuspenseQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<ResourceAdminIndex["data"], ResourceAdminIndex["error"]>({
                method: "get",
                url: `/api/v5/admin/resources`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary list
 * @link /api/v5/admin/resources
 */
export function useResourceAdminIndexSuspense<TData = ResourceAdminIndex["response"], TQueryKey extends QueryKey = ResourceAdminIndexSuspenseQueryKey>(params?: ResourceAdminIndex["queryParams"], options: {
    query?: Partial<UseSuspenseQueryOptions<ResourceAdminIndex["response"], ResourceAdminIndex["error"], TData, TQueryKey>>;
    client?: ResourceAdminIndex["client"]["parameters"];
} = {}): UseSuspenseQueryResult<TData, ResourceAdminIndex["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? resourceAdminIndexSuspenseQueryKey(params);
    const query = useSuspenseQuery({
        ...resourceAdminIndexSuspenseQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseSuspenseQueryResult<TData, ResourceAdminIndex["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}